module.exports = __webpack_public_path__ + "static/media/paint-roller-2.321e06c3.jpeg";